module.exports = __webpack_public_path__ + "static/media/2017Earthfest4.a55d13b6.jpg";